import React, { Component } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
/**
 *  Home Page Popup Modal
 */
import TabNav from './TabNav'
import Tab from './Tab'
import colors from "./colors";
import ReactHTMLParser from "react-html-parser";
import minimize from './minimise_button_a.png'
class AboutModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 'About Portal'
    }
  }
  setSelected = (tab) => {
    this.setState({ selected: tab });
  }
  render() {
    // console.log(this.props)
    return (
      <MDBContainer >
        {/* <MDBBtn color="primary" onClick={this.toggle(14)}>MDBModal</MDBBtn> */}
        <MDBModal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          centered
          backdrop={false}
          size="lg"
        //     style={{
        //   textAlign: "justify",
        //   width: window.innerWidth<1000?"250px":"600px",

        //   overflow: "scroll",
        // }}
        >
          <div className="modal-header text-center"

            toggle={this.props.toggle}
            style={{ background: colors.graphical, color: "white" }}>
            <h4 className="modal-title w-100 font-weight-bold">
              <TabNav tabs={['About Portal', 'About NHP', 'About NRSC@NHP']} selected={this.state.selected} setSelected={this.setSelected}>

              </TabNav>
            </h4>
            <img src={minimize} class="btn-close" style={{ width: "20px", height: "20px", cursor: "pointer" }} title="minimize" onClick={this.props.toggle} />
            {/* <button
              type="button"
              class="btn-close"
              
              style={{background:"url(minimize)"}}
              aria-label="Minimize"
              onClick={this.props.toggle}
            ></button> */}
          </div>
          {/* <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            toggle={this.props.toggle}
            style={{ background: "#3f51b5", color: "white" }}
          >

            <TabNav tabs={['About Portal', 'About NHP', 'About NRSC@NHP']} selected={this.state.selected} setSelected={this.setSelected}>

            </TabNav>
          </MDBModalHeader> */}
          <MDBModalBody
            style={{
              textAlign: "justify",
              height: window.innerHeight > 1000 ? "500px" : "300px",

              overflowY: "scroll",
            }}
          >
            <Tab isSelected={this.state.selected === 'About Portal'}>
              {ReactHTMLParser(this.props.aboutportal)}
            </Tab>
            <Tab isSelected={this.state.selected === 'About NHP'}>
              {ReactHTMLParser(this.props.aboutnhp)}
            </Tab>
            <Tab isSelected={this.state.selected === 'About NRSC@NHP'}>
              {ReactHTMLParser(this.props.aboutnrscatnhp)}
            </Tab>

            {/* {ReactHTMLParser(this.props.bodycontent)} */}
          </MDBModalBody>
          <hr />
          <footer
            className="page-footer font-small "
            style={{
              backgroundColor: colors.white,
              borderTop: "1px solid #dee2e6",
              height: "auto",
            }}
          />
        </MDBModal>
      </MDBContainer>
    );
  }
}

export default AboutModal;
